import { TimeWorkClosedDto } from "../model";
import { DateUtils } from "./date.utils";
import { converteStringToNumber } from "./formatMoney";

export class CalculateTheMonthOfWork {
  static getTotalForProjectsMonth(collaboratorTimeWork: TimeWorkClosedDto[], label: string): number {
    return this.getTotalHoursForAllProjects(collaboratorTimeWork, label);
  }

  private static isPayForHoursWorkded(pay_config) {
    return pay_config === "HOURS" ? true : false;
  }

  private static getTotalHoursForAllProjects(collaboratorTimeWork: TimeWorkClosedDto[], label: string) {
    return collaboratorTimeWork.reduce((acc, user) => (acc += this.getHoursPayForProject(user, label)), 0);
  }

  static getHoursPayForProject(user: TimeWorkClosedDto, label: string, days?: number) {
    if (this.isPayForHoursWorkded(user.pay_config)) return DateUtils.convertStringTimeToNumber(user[label]) * converteStringToNumber(user.hourly_pay);
    
    const monthlyPayment = Number(user.monthly_pay)
    const dailyPayment = monthlyPayment / (days ? days : 30);

    const totalDaysWorkedInMonth = DateUtils.convertStringTimeToNumber(user[label]) / (days ? 8 : 5.6);
    return totalDaysWorkedInMonth * dailyPayment;
  }

  static getTotalHours(collaboratorTimeWork: TimeWorkClosedDto[]) {
    const total = collaboratorTimeWork.reduce((acc, item) => (acc += this.getSumHoursForProject(item)), 0);
    return DateUtils.convertNumberTimeToString(total);
  }

  private static getSumHoursForProject(user: TimeWorkClosedDto) {
    return DateUtils.convertStringTimeToNumber(user.timeApproved);
  }
}
